/* eslint-disable no-nested-ternary */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Header from '../../components/Header';
import SubNav from '../../components/SubNav';
import Footer from '../../components/Footer';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import styles from './index.css';
import ToTop from '@ifeng-fe/container_channel/common/client/components/toTop';
import Chip from 'Chip';
import MainBox from './components/MainBox';

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        // 头部
        const headerData = {
            nav: { ...content.nav, limit: 17 },
            topAd: content.topAd,
            search: content.search,
            logo: content.logo,
        };

        const footerData = {
            footerNav: content.footerNav,
            footerCopyright: content.footerCopyright,
        };

        return (
            <div>
                <div className={styles.headerWrap}>
                    <Header content={headerData} />
                </div>
                <Chip id="230203" type="struct" title="凤凰卫视-首页子导航" groupName="正文" content={content.subNav}>
                    <SubNav theme={styles.subNav} />
                </Chip>
                <div className={styles.main}>
                    <Chip id="285157" type="recommend" title="凤凰卫视-管理层列表" groupName="正文">
                        <MainBox />
                    </Chip>
                </div>
                <div className={styles.footerWrap}>
                    <Footer content={footerData} />
                </div>
                <ToTop windowMode="normal" />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
